<script setup>
defineProps({
  message: { type: String, default: null },
  variant: { type: String, default: '' },
  actionLabel: { type: String, default: '' },
})
defineEmits(['action'])
</script>

<template>
  <div class="state-empty" :class="{ error: variant === 'error' }" :role="variant === 'error' ? 'alert' : 'status'">
    <p>{{ message ?? $t('ui.noItemsFound') }}</p>
    <button v-if="actionLabel" type="button" class="btn ghost mt-3" @click="$emit('action')">{{ actionLabel }}</button>
  </div>
</template>
